import { useContext } from 'react';

import { IntlContext } from '../../IntlProvider/IntlProvider';

const useIntl = () => useContext(IntlContext);

export default useIntl;
